import { Steps } from '../shared/steps-model';
import { Injectable, EventEmitter, Output, ElementRef } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ModalStartScreenComponent } from '../shared/modals/modal-start-screen/modal-start-screen.component';
import { MatDialog } from '@angular/material';
import { CookieServiceService } from './cookie-service.service';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class TourService {

  open: EventEmitter<boolean> = new EventEmitter();
  showCurrentStep: EventEmitter<Steps> = new EventEmitter();
  resetTour: EventEmitter<number> = new EventEmitter();

  private currentStep = 1;
  private countNodes = 0;
  private visible: boolean;
  public steps: Steps[] = [
    {
      "step": 1,
      "title": "First, create a deck",
      "text": "Choose a basic deck shape and customize with our shaping tools. Set the height, add tiers and/or stairs, adjacent walls, scenery, and accessories.",
      "position": "",
      "elements": []
    },
    {
      "step": 2,
      "title": "Then build your railing",
      "text": "Choose your railing material and type, post mounting and corners, top rail, railing infill, color, and other options.",
      "position": "",
      "elements": []
    },
    {
      "step": 3,
      "title": "Manage your projects",
      "text": "Save, share, and print your project, open a saved project, or take a tour of the tool functionality.",
      "position": "",
      "elements": []
    },
    {
      "step": 4,
      "title": "Viewing Tools",
      "text": "Easily switch between 3D and 2D views of your deck project. Snap a screen shot, toggle dimensions on and off, and change the lighting to see how the deck and railing change during the day.",
      "position": "",
      "elements": []
    },
    {
      "step": 5,
      "title": "Settings and Help",
      "text": "Change unit of measurement setting. Get help and send feedback.",
      "position": "",
      "elements": []
    },
    {
      "step": 6,
      "title": "Perspective Controls",
      "text": "Change the viewing angle in 3D mode, zoom and pan to see your deck from multiple angles.",
      "position": "",
      "elements": []
    },
    {
      "step": 7,
      "title": "Next steps",
      "text": "Share, print, and save your project. Click GET A QUOTE to send your project to the local Feeney dealer of your choice.",
      "position": "",
      "elements": []
    }
  ];
  private tourOpenFirstTime = true;

  constructor(
    private http: HttpClient,
    private dialog: MatDialog,
    private cookieServiceService: CookieServiceService
  ) {
  }


  public addStep(element: ElementRef, step: number, stepPosition?: string) {
    const item: Steps = this.steps.find((i) => i.step === step);

    // If element got position attribute - save it to step.position
    if (stepPosition) {
      item.position = stepPosition;
    }
    item.elements.push(element);
    this.countNodes++;

    // if (this.countNodes === 6) {
    //   setTimeout(() => {
    //     this.getPosHelp();
    //   }, 0);
    // }
  }

  goToStep(n) {
    this.currentStep = n;
    this.showStep(this.nextStep);
  }

  showStep(handler) {
    // Save element from steps[] with currentStep value
    const data = this.steps.find((item) => item.step === this.currentStep);

    // If we have 1 or more nodes in elements[] set class 'active' for every element
    if (data.elements.length) {
      // Remove all classes 'active' from steps[]
      this.steps.forEach((item, index, arr) => {
        item.elements.forEach((nodeItem, nodeIndex, nodeArr) => {
          nodeItem.nativeElement.classList.remove('border-shadow');
        });
      });
      // Add class 'active' for all nodes in current step
      data.elements.forEach((item, index, arr) => {
        item.nativeElement.classList.add('border-shadow');
      });

      // Emit element to component
      this.showCurrentStep.emit(data);
    } else {
      // Remove all classes 'active' from steps[]
      this.steps.forEach((item, index, arr) => {
        item.elements.forEach((nodeItem, nodeIndex, nodeArr) => {
          nodeItem.nativeElement.classList.remove('border-shadow');
        });
      });
      // Call handler function
      handler();
    }
  }

  nextStep() {
    if (this.currentStep === this.steps.length) {
      // If currentStep is last - close tour and reset currentStep count
      this.closeTour();
      this.currentStep = 1;
    } else {
      this.currentStep++;
      this.showStep(this.nextStep.bind(this));
    }
  }

  previousStep() {
    // We can call previousStep() only for 2-d and higher step
    if (this.currentStep > 1) {
      this.currentStep--;
      this.showStep(this.previousStep.bind(this));
    }
  }

  closeTour() {
    if (this.currentStep === 1) {
      document.getElementsByClassName('active step_1_top')[0].classList.remove('border-shadow', 'hide-bottom-border');
      this.resetTour.emit(0);
    }
    if (this.currentStep === 2) {
      document.getElementById('step_2').classList.remove('active');
      document.getElementById('step_1').classList.add('active');
      document.getElementsByClassName('step_2_top')[0].classList.remove('border-shadow', 'hide-bottom-border', 'active');
    }
    if (this.currentStep === 3) {
      document.getElementsByClassName('dropdown actions-dropdown')[0].classList.remove('border-shadow', 'hide-bottom-border', 'open');
      // console.log(document.getElementsByClassName('dropdown actions-dropdown')[0].classList);
    }
    this.currentStep = 1;

    // Remove all classes 'active' from steps[]
    this.steps.forEach((item, index, arr) => {
      item.elements.forEach((nodeItem, nodeIndex, nodeArr) => {
        nodeItem.nativeElement.classList.remove('border-shadow', 'no-left-half', 'hide-top-border', 'no-right-half');
      });
    });

    const el: HTMLElement = document.getElementsByClassName('tab-1-open')[0] as HTMLElement;
    el.click();
    this.visible = false;
    // Emit false value to close tour
    this.open.emit(false);
    if (this.cookieServiceService.getCookie('isTourViewed') !== 'viewed') {
      this.cookieServiceService.setCookie('isTourViewed', 'viewed', 90);
      this.dialog.open(ModalStartScreenComponent, {
        width: '835px',
        height: '75vh',
        data: 'Data'
      });
    }
  }

  showTour() {
    this.visible = true;
    // Emit true value to open tour
    this.open.emit(true);
    this.showStep(this.nextStep.bind(this));

  }

  getStepsCount() {
    // Count all steps that has at least 1 node in document
    const liveSteps = this.steps.filter((item) => item.elements.length);
    return liveSteps.length;
  }

  getTooltipsPos(index) {
    const tooltips = [];
    const leftMenu: HTMLElement = document.getElementsByClassName('controls-sidebar')[0] as HTMLElement;

    switch (index) {
      case 4: {
        const parent = this.steps[3].elements[0].nativeElement.parentElement;
        const offsetLeftToolbar = parent.parentElement.parentElement.offsetLeft;
        const offsetLeftWrapper = parent.parentElement.offsetLeft;
        const offsetTopToolbar = parent.parentElement.parentElement.offsetTop;
        const toolbarHeight = parent.parentElement.parentElement.clientHeight;
        const offsetTopAmount = offsetTopToolbar + toolbarHeight - 7;
        const offsetLeftAmount = offsetLeftToolbar + offsetLeftWrapper + leftMenu.clientWidth;
        const dayTimeControl = {
          name: 'dayTimeControl',
          top: offsetTopAmount + 67,
          left: offsetLeftAmount + 150
        };
        const twoD = {
          name: 'twoD',
          top: offsetTopAmount + 37,
          // left: offsetLeftAmount + 100
          left: offsetLeftAmount - 50
        };
        const threeD = {
          name: 'threeD',
          top: offsetTopAmount + 67,
          left: offsetLeftAmount + 5
        };
        const takeSs = {
          name: 'takeSs',
          top: offsetTopAmount + 92,
          left: offsetLeftAmount + 61
        };
        const dimensions = {
          name: 'dimensions',
          top: offsetTopAmount + 92,
          left: offsetLeftAmount + 205
        };
        const undo = {
          name: 'undo',
          top: offsetTopAmount + 117,
          left: offsetLeftAmount + 260
        };
        tooltips.push(dayTimeControl, twoD, threeD, takeSs, dimensions, undo);
      } break;
      case 5: {
        const parent = this.steps[4].elements[0].nativeElement.parentElement;
        const offsetItem = this.steps[4].elements[0].nativeElement.offsetLeft;
        const offsetLeftParent = parent.offsetLeft;
        const offsetLeftParentParent = parent.parentElement.offsetLeft;
        const offsetTopAmount = parent.parentElement.offsetTop + parent.parentElement.clientHeight;
        const offsetLeftAmount = offsetItem + offsetLeftParent + offsetLeftParentParent + leftMenu.clientWidth;
        const settingsTooltip = {
          name: 'settings',
          top: offsetTopAmount + 35,
          left: offsetLeftAmount + 10,
        };
        const helpTooltip = {
          name: 'help',
          top: offsetTopAmount + 50,
          left: offsetLeftAmount + 70,
        };
        tooltips.push(settingsTooltip, helpTooltip);
      } break;
      case 6: {
        const parentOffsetTop = this.steps[5].elements[0].nativeElement.parentElement.offsetTop;
        const parentOffsetLeft = this.steps[5].elements[0].nativeElement.parentElement.offsetLeft;
        const angleCtrl = {
          name: 'angleCtrl',
          top: parentOffsetTop + 30,
          left: parentOffsetLeft + leftMenu.clientWidth - 143,
        };
        const panningCtrl = {
          name: 'panningCtrl',
          top: parentOffsetTop + 54,
          left: parentOffsetLeft + leftMenu.clientWidth - 143,
        };
        const zoomCtrl = {
          name: 'zoomCtrl',
          top: parentOffsetTop + 116,
          left: parentOffsetLeft + leftMenu.clientWidth - 143,
        };
        tooltips.push(angleCtrl, panningCtrl, zoomCtrl);
      } break;
    }
    return tooltips;

  }
  // Collect coordinates to set positions for helpIcons
  // Suitable only for current markup
  getPosHelp() {
    const helpArr = [];

    const leftMenu: HTMLElement = document.getElementsByClassName('controls-sidebar')[0] as HTMLElement;

    for (let i = 0, l = this.steps.length; i < l; i++) {

      switch (this.steps[i].step) {
        case 1: {
          const el: HTMLElement = document.getElementsByClassName('step_1_top')[0] as HTMLElement;

          const offsetTopAmount = el.offsetTop + 8;
          const offsetLeftAmount = el.clientWidth + el.offsetLeft - 41;
          const helpItem = {
            step: 1,
            top: offsetTopAmount,
            left: offsetLeftAmount,
          };
          helpArr.push(helpItem);
        } break;
        case 2: {
          const el: HTMLElement = document.getElementsByClassName('step_2_top')[0] as HTMLElement;

          const offsetTopAmount = el.offsetTop + 8;
          const offsetLeftAmount = el.clientWidth + el.offsetLeft - 41;
          const helpItem = {
            step: 2,
            top: offsetTopAmount,
            left: offsetLeftAmount,
          };
          helpArr.push(helpItem);
        } break;
        case 3: {
          const parent = this.steps[i].elements[0].nativeElement.parentElement;
          const offsetLeftToolbar = parent.parentElement.parentElement.offsetLeft;
          const offsetTopToolbar = parent.parentElement.parentElement.offsetTop;
          const toolbarHeight = parent.parentElement.parentElement.clientHeight;
          const parentCenter = parent.parentElement.clientWidth / 2;
          const offsetTopAmount = offsetTopToolbar + toolbarHeight - 7;
          const offsetLeftAmount = offsetLeftToolbar + parentCenter + leftMenu.clientWidth - 10;

          const helpItem = {
            step: 3,
            top: offsetTopAmount,
            left: offsetLeftAmount,
          };
          helpArr.push(helpItem);
        } break;
        case 4: {
          const parent = this.steps[i].elements[0].nativeElement.parentElement;
          const offsetLeftToolbar = parent.parentElement.parentElement.offsetLeft;
          const offsetLeftWrapper = parent.parentElement.offsetLeft;
          const offsetTopToolbar = parent.parentElement.parentElement.offsetTop;
          const parentCenter = parent.clientWidth / 2;
          const toolbarHeight = parent.parentElement.parentElement.clientHeight;
          const offsetTopAmount = offsetTopToolbar + toolbarHeight - 7;
          const offsetLeftAmount = offsetLeftToolbar + offsetLeftWrapper + parentCenter + leftMenu.clientWidth - 10;

          const helpItem = {
            step: 4,
            top: offsetTopAmount,
            left: offsetLeftAmount,
          };
          helpArr.push(helpItem);
        } break;
        case 5: {
          const parent = this.steps[i].elements[0].nativeElement.parentElement;
          const offsetItem = this.steps[i].elements[0].nativeElement.offsetLeft;
          const offsetLeftParent = parent.offsetLeft;
          const offsetLeftParentParent = parent.parentElement.offsetLeft;
          const offsetTopAmount = parent.parentElement.offsetTop + parent.parentElement.clientHeight - 7;
          const offsetLeftAmount = offsetItem + offsetLeftParent + offsetLeftParentParent + leftMenu.clientWidth + 38;

          const helpItem = {
            step: 5,
            top: offsetTopAmount,
            left: offsetLeftAmount + 20
          };
          helpArr.push(helpItem);
        } break;
        case 6: {
          const parent = this.steps[i].elements[0].nativeElement.parentElement;
          const helpItem = {
            step: 6,
            top: parent.offsetTop + 60,
            left: parent.offsetLeft + leftMenu.clientWidth - 40
          };
          helpArr.push(helpItem);
        } break;
        case 7: {
          const parent = this.steps[i].elements[0].nativeElement.parentElement;
          const helpItem = {
            step: 7,
            top: parent.offsetTop - 20,
            left: parent.offsetLeft + 140
          };
          helpArr.push(helpItem);
        } break;
        default: {
          console.error('Get HelpIcon position failed');
        }
      }
    }
    // console.log(helpArr);
    return helpArr;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/tour.service.ts